import React from 'react';

import { AppTextField } from 'components/form/appTextField';

export const PreviewAnswers = ({ name, index }: any) => {
  return <AppTextField name={name} label={`#${index + 1}`} disabled placeholder="-" />;
};
